import React from 'react';

function FourOhFour() {
  return <div data-testid="content">Womp, womp! Page Not Found...</div>;
}

export default FourOhFour;
